<template lang="">
    <div class="contents">
      <div class="signUp_wrap">
          <div class="signUp_head">
              <h5 class="tit">회원가입</h5>
              <ul class="step">
                  <li>01. 약관동의</li>
                  <li>02. 정보입력</li>
                  <li class="on">03. 가입완료</li>
              </ul>
          </div>
          <div class="signUp_body">
              <div class="signUp_final">
                  <div class="mark"></div>
                  <div class="main_txt">
                      <b>{{ name }}</b> 회원님 <br>
                      블러썸로고스의 회원이 되신 것을 진심으로 환영합니다.
                  </div>
                  <p class="sub_txt">다양하고 편리한 서비스와 풍성한 혜택으로 정성껏 모시겠습니다. 감사합니다.</p>
                  <div class="btn_box">
                      <button type="button" class="kakao" @click="connectKakao">
                          카카오 간편 로그인 연결하기
                      </button>
                      <button type="button" class="naver" @click="connectNaver">
                          네이버 간편 로그인 연결하기
                      </button>
                  </div>
                  <a @click="toHome" class="btn_backHome">홈으로 가기</a>
                  <div class="last_txt">
                      <span>마이페이지>SNS 간편 로그인 연결</span>에서 계정 수정이 가능합니다.
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

const accountModule = 'accountModule'

export default {
  data () {
    return {
      name: localStorage.getItem("accountName")
    }
  },

  methods: {
    ...mapActions(accountModule, [
        'requestKakaoOauthConnectRedirectUrl',
        'requestNaverOauthConnectRedirectUrl'
    ]),

    nextPage() {
      this.$emit('nextPage')
    },

    toHome() {
      this.$router.push({ name: 'home' })
    },

    async connectKakao() {
      await this.requestKakaoOauthConnectRedirectUrl()
    },

    async connectNaver() {
        await this.requestNaverOauthConnectRedirectUrl()
    }
  }
}
</script>
<style lang="">

</style>